import React, { useEffect, useState, useRef } from "react";
import "./styles.css";
import Map from "../../components/Map/Map";
import Button from "../../components/Button/Button";
import SendArrow from "../../img/SendArrow";
import Confetti from "react-confetti";
import { QRCodeCanvas } from "qrcode.react";
import { useWindowSize } from "react-use";

function NewSummary({
  selectedBrand,
  selectedModel,
  selectedStorage,
  buttonsCondition,
  exteriorCondition,
  screenCondition,
  grade,
  deliveryMethod,
  UserData,
  scheduleInfo,
  sendInfoData,
  selectedOffer,
  batteryLevel,
}) {
  const tagend = window.tagend;
  const redirectUrl = window.redirectUrl;
  const currentURL = window.location.href;
  const isCelucambio = currentURL.includes("celucambio");
  const isQuieromac = currentURL.includes("quieromac");

  const startTime = scheduleInfo?.hour?.start || scheduleInfo?.start_time;
  const endTime = scheduleInfo?.hour?.end || scheduleInfo?.end_time;

  const [showConfetti, setShowConfetti] = useState(true);
  const [id, setId] = useState();
  const { width, height } = useWindowSize();

  const qrRef = useRef();

  const downloadQRCode = () => {
    const canvas = qrRef.current.querySelector("canvas");
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = `qr-code-${id}.png`;
    link.click();
  };

  let day = "";
  let month = "";
  if (scheduleInfo?.date?.day) {
    day = scheduleInfo?.date?.day;
    month = scheduleInfo?.date?.month;
  } else if (scheduleInfo?.date) {
    const [year, monthFromDate, dayFromDate] = scheduleInfo?.date?.split("-");
    day = dayFromDate;
    month = monthFromDate;
  }

  useEffect(() => {
    const requestData = {
      email: UserData?.email,
      phone: UserData?.phone,
      brand: selectedBrand,
      product: selectedModel?.name,
      model_id: selectedModel?.id,
      storage_id: selectedStorage?.storage_id,
      final_grade: grade,
      final_price: selectedOffer?.price,
      turns_on_and_buttons_ok: buttonsCondition,
      exterior_is_ok: exteriorCondition,
      cameras_and_touchscreen: screenCondition,
      product_id: selectedOffer?.product_id,
      schedule_date: scheduleInfo?.date,
      schedule_time: `${scheduleInfo?.start_time} / ${scheduleInfo?.end_time}`,
      schedule_id: scheduleInfo?.scheduleId,
      address: scheduleInfo?.address,
      address2: scheduleInfo?.address2,
      delivery: deliveryMethod === "domicilio",
      payment_period: selectedOffer?.paymentPeriod,
      battery_level: batteryLevel,
    };

    const saveCompleted = async () => {
      try {
        const response = await fetch(
          "https://api.quieromac.com/retomas/inventory/celucambio/save_completed",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );
        console.log(response);
        if (response.ok) {
          const data = await response.json();
          setId(data.id);
          if (window.plausible) {
            window.plausible(`finished_flux${tagend}`);
          } else {
            console.error("Plausible is not defined");
          }
        } else {
          console.error("Request to save_completed endpoint failed");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    saveCompleted();

    // Hide confetti after 5 seconds
    const confettiTimer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);

    return () => clearTimeout(confettiTimer);
  }, [
    UserData,
    selectedBrand,
    selectedModel,
    selectedStorage,
    grade,
    selectedOffer,
    scheduleInfo,
    tagend,
  ]);

  const handleFinalize = () => {
    window.location.href = redirectUrl;
  };

  return (
    <div className="NewSummary">
      {showConfetti && <Confetti width={width} height={height} />}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="70"
        height="70"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-party-popper w-24 h-24 mx-auto text-yellow-400"
        data-id="126"
      >
        <path d="M5.8 11.3 2 22l10.7-3.79"></path>
        <path d="M4 3h.01"></path>
        <path d="M22 8h.01"></path>
        <path d="M15 2h.01"></path>
        <path d="M22 20h.01"></path>
        <path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"></path>
        <path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11v0c-.11.7-.72 1.22-1.43 1.22H17"></path>
        <path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98v0C9.52 4.9 9 5.52 9 6.23V7"></path>
        <path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"></path>
      </svg>
      <h1>¡Felicitaciones!</h1>
      <h2>Valor de retoma:</h2>
      <p className="priceBig">
        ${selectedOffer?.price?.toLocaleString("es-CO")}{" "}
      </p>
      <p className="descripcionOffer">
        {" "}
        Has completado el proceso de evaluación de tu celular.
      </p>
      <p className="descripcionOffer">
        Nos pondremos en contacto contigo pronto para finalizar el proceso.
      </p>
      {deliveryMethod != "domicilio" && (
        <div className="cardSummary qr">
          <p>
            Muestra este QR en el punto de venta para recibir un 3% extra en el
            valor de tu dispositivo
          </p>
          <div ref={qrRef}>
            <QRCodeCanvas value={id} size={100} />
          </div>
          <Button onClick={downloadQRCode}>Descargar QR</Button>
        </div>
      )}
      <div className="containerSummary">
        <div className="cardSummary">
          <div className="cardScheduleInfo">
            {isCelucambio && <p className="title">Celucambio</p>}
            {isQuieromac && <p className="title">Quieromac</p>}
            {deliveryMethod !== "domicilio" ? (
              <>
                <p className="description">
                  <span>{sendInfoData?.selectedSede?.name}</span>
                </p>
                <p className="description">
                  {sendInfoData?.selectedSede?.location}
                </p>
                <p className="description">
                  <span>
                    {day} de {month}, entre las {startTime} a las {endTime}
                  </span>
                </p>
              </>
            ) : (
              <>
                <p className="description">Recoger en domicilio</p>
                <p className="description">{scheduleInfo?.address}</p>
                <p className="description">{scheduleInfo?.extraAddressInfo}</p>
              </>
            )}
          </div>
          {deliveryMethod !== "domicilio" && (
            <Map address={sendInfoData?.selectedSede?.location} type="small" />
          )}
        </div>
        <div className="cardSummary">
          <div>
            <p className="title">{selectedModel?.name}</p>
            {grade === "D" && <p className="title">Precio pendiente</p>}
            <p className=".subtitle">{sendInfoData?.selectedSede?.name}</p>
            {grade === "A" && <p className=".subtitle">Excelente estado</p>}
            {grade !== "A" && grade !== "D" && (
              <p className=".subtitle">Estado regular</p>
            )}
            {grade === "D" && <p className=".subtitle">Estado pendiente</p>}
          </div>
          <img
            src={selectedModel?.image}
            alt={selectedModel?.name}
            className="card-image"
          />
        </div>
      </div>
      <div className="buttonSpace">
        <Button type="black" onClick={handleFinalize}>
          <div className="buttonContainerEnd">
            <p>Finalizar</p>
            <SendArrow />
          </div>
        </Button>
      </div>
    </div>
  );
}

export default NewSummary;
